import { Dispatch, ThunkAction } from '../../../types/actions';
import { IUserMetaQualificationForm } from '../../../types/rest/IUserMeta';
import { IAuthUser } from '../../../store/model/authUser/types';
import { authUserPatch } from './api/helper/authUserPatch';
import { TUserId } from '../../../types/rest/IRestAuthUser';

export const authUserSetQualificationFormMeta = (
    userId: TUserId,
    qualificationForm: IUserMetaQualificationForm
): ThunkAction => {
    const action = (
        dispatch: Dispatch
    ) => {
        const userPatch: IAuthUser = {
            id: userId,
            meta: {
                qualificationForm
            }
        };
        return dispatch(authUserPatch(userPatch));
    };
    return action;
};
